<template>
  <el-dialog
    title="我的成绩"
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="500px"
    center
    :show-close="true"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    class="score-dialog"
  >
    <div class="score-content">
      <div class="score-circle">
        <div class="score-value">{{ score }}</div>
        <div class="score-label">考试分数</div>
      </div>
      <div class="score-info">
        <div class="info-row">
          <span class="info-label">项目名称：</span>
          <span class="info-value">{{ projectName }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">考试时间：</span>
          <span class="info-value">{{ examTime }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">通过状态：</span>
          <span class="info-value" :class="score >= passingScore ? 'passed' : 'failed'">
            {{ score >= passingScore ? '通过' : '未通过' }}
          </span>
        </div>
        <div class="info-row">
          <span class="info-label">及格分数：</span>
          <span class="info-value">{{ passingScore }}</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handlePrint">打印成绩</el-button>
      <el-button type="primary" @click="handleRetry">重新考试</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ScoreDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectName: {
      type: String,
      default: ''
    },
    score: {
      type: Number,
      default: 0
    },
    examTime: {
      type: String,
      default: ''
    },
    passingScore: {
      type: Number,
      default: 60
    }
  },
  methods: {
    handlePrint() {
      // 处理成绩打印逻辑
      this.$message.info('成绩打印功能待实现')
    },
    handleRetry() {
      // 处理重新考试逻辑
      this.$message.info('重新考试功能待实现')
    }
  }
}
</script>

<style scoped lang="scss">
.score-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #ebeef5;
    padding: 20px 20px 10px;
  }
  
  .el-dialog__title {
    text-align: center;
    font-weight: bold;
  }
  
  .el-dialog__body {
    padding: 30px 20px;
  }
}

.score-content {
  text-align: center;
}

.score-circle {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #4034eb, #6a5af9);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto 30px;
  color: #fff;
}

.score-value {
  font-size: 48px;
  font-weight: bold;
}

.score-label {
  font-size: 16px;
  margin-top: 5px;
  opacity: 0.9;
}

.score-info {
  text-align: left;
  margin-top: 20px;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
  font-size: 16px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  width: 120px;
  color: #606266;
}

.info-value {
  color: #333;
  font-weight: 500;
}

.info-value.passed {
  color: #67c23a;
}

.info-value.failed {
  color: #f56c6c;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.dialog-footer .el-button--primary {
  background-color: #4034eb;
  border-color: #4034eb;
}
</style>